import DeviceGroup from './DeviceDropdownSelectorGroup';

export default DeviceGroup;
